const getListByKeyword = (list, keyword, isOpen) => {
	let newList = []
	if (list)
		list.forEach(node => {
			let isContains = false
			let newNode = JSON.parse(JSON.stringify(node))
			if (newNode.name.includes(keyword)) isContains = true
			if (newNode.members) {
				const members = newNode.members.filter(m =>
					m.name.includes(keyword)
				)
				if (members.length > 0) {
					isContains = true
					newNode.members = members
				} else if (!newNode.name.includes(keyword)) {
					newNode.members = []
				}
			}
			if (newNode.storages) {
				const storages = getListByKeyword(
					node.storages,
					keyword,
					isOpen
				)
				if (storages.length > 0) {
					isContains = true
					newNode.storages = storages.map(ch => {
						return { ...ch, isOpen: isOpen ?? keyword.length > 0 }
					})
				} else if (newNode.name.includes(keyword)) {
					newNode.storages = newNode.storages.map(ch => {
						return { ...ch, isOpen: isOpen ?? false }
					})
				} else {
					newNode.storages = []
				}
			}
			if (newNode.children) {
				const children = getListByKeyword(
					node.children,
					keyword,
					isOpen
				)
				if (children.length > 0) {
					isContains = true
					newNode.children = children.map(ch => {
						return { ...ch, isOpen: isOpen ?? keyword.length > 0 }
					})
				} else if (newNode.name.includes(keyword)) {
					newNode.children = newNode.children.map(ch => {
						return { ...ch, isOpen: isOpen ?? false }
					})
				} else {
					newNode.children = []
				}
			}
			if (isContains || newNode.storages?.length > 0)
				newList.push({
					...newNode,
					isOpen:
						isOpen ??
						(keyword.length > 0 ||
							(newNode.parentId == null && !newNode.locationId)),
				})
		})
	return newList
}

const getListBySelected = (list, selectdIds) => {
	let newList = []
	if (list)
		list.forEach(node => {
			let isContains = false
			let newNode = JSON.parse(JSON.stringify(node))
			if (selectdIds.includes(node.id)) isContains = true
			if (newNode.members?.some(m => selectdIds.includes(m.id))) {
				isContains = true
			}
			if (newNode.storages) {
				const storages = getListBySelected(node.storages, selectdIds)
				if (storages.some(s => s.isOpen == true)) {
					isContains = true
				}
				newNode.storages = storages
			}
			if (newNode.children) {
				const children = getListBySelected(node.children, selectdIds)
				if (children.some(s => s.isOpen == true)) {
					isContains = true
				}
				newNode.children = children
			}
			newList.push({
				...newNode,
				isOpen:
					isContains ||
					(newNode.parentId == null && !newNode.locationId),
			})
		})
	return newList
}

const getStorageIds = list => {
	let arr = []
	if (list) {
		list.forEach(node => {
			if (node.accessible || true)
				arr.push(...getStorageIds(node.children))
			if (node.locationId) arr.push(node.id)
			if (node.storages) {
				// arr.push(...node.storages.map(s => s.id))
				arr.push(...getStorageIds(node.storages))
			}
		})
	}
	return arr
}

const getStorageCount = list => {
	let count = 0
	if (list) {
		list.forEach(node => {
			if (node.accessible || true) count += getStorageCount(node.children)
			if (node.locationId) count++
			if (node.storages) {
				count += getStorageCount(node.storages)
			}
		})
	}
	return count
}

export { getListByKeyword, getListBySelected, getStorageIds, getStorageCount }
